module.exports = __webpack_public_path__ + "img/large-small-site.6e3da1cd.png";